<script lang="ts">
  import "../app.css"
  import "$lib/polyfills.js" // Import polyfills first
  import { page } from "$app/stores"
  // import "../app.postcss" // Removed: CSS should be loaded globally, not imported in Svelte files
  import { navigating } from "$app/stores"
  import { browser } from "$app/environment"
  import { onMount } from "svelte"
  import { fade, slide } from "svelte/transition"
  import { afterNavigate, invalidate, invalidateAll } from "$app/navigation"
  import Navbar from "$lib/components/layout/Navbar.svelte"
  import Footer from "$lib/components/layout/Footer.svelte"

  export let data
  $: session = typeof data?.session === 'string' ? JSON.parse(data.session) : data?.session || null

  // Invalidate session after navigation to /logout to update Navbar immediately
  afterNavigate(({ to }) => {
    if (to?.url.pathname === "/logout") {
      invalidate("/", { reload: true })
    }
  })
  // const user = data?.user || null // Removed: not present in data

  // Dark mode
  const dark = true

  // Route protection logic can be added here if needed
  $: isAdminRoute = $page.url.pathname.startsWith("/account")

  // Check if we're on the home page to decide whether to show the animation
  $: isHomePage = $page.url.pathname === "/"

  // After navigation, scroll to top
  afterNavigate(({ to }) => {
    const hash = to?.url.hash
    if (!hash) {
      window.scrollTo({ top: 0 })
    }
  })

  onMount(() => {
    if (browser && data.supabase) {
      const result = data.supabase.auth.onAuthStateChange(() => {
        invalidateAll()
      })
      console.log("Supabase onAuthStateChange return value:", result)
      return () => {
        if (
          result &&
          result.data &&
          result.data.subscription &&
          typeof result.data.subscription.unsubscribe === "function"
        ) {
          result.data.subscription.unsubscribe()
        }
      }
    }
  })

  // Get current URL path
  $: path = $page.url.pathname

  // Determine if current page has its own layout
  // Only treat /blog pages as custom layout (admin uses main navbar)
  $: hasCustomLayout = ["/blog", "/blog/"].some((prefix) =>
    path.startsWith(prefix),
  )
  $: useMainLayout = !hasCustomLayout
</script>



<!-- Main app container with dark theme -->
<div class="app-container text-white">
  <!-- Loading bar -->
  {#if $navigating}
    <div
      class="fixed w-full top-0 right-0 left-0 h-1 z-50"
      in:slide={{ duration: 300, axis: "x" }}
      out:fade={{ duration: 200 }}
    >
      <div class="loading loading-dots loading-lg text-accent"></div>
    </div>
  {/if}

  <!-- For non-blog pages, show navbar and footer -->
  {#if !hasCustomLayout}
    <!-- Fixed navbar -->
    <Navbar {dark} {session} />

    <!-- Main content with padding for fixed navbar -->
    <main class="relative z-10 min-h-screen pt-16">
      <slot />
    </main>

    <!-- Footer -->
    <Footer />
  {:else}
    <!-- Blog pages have their own layout with navbar/footer -->
    <slot />
  {/if}
</div>

<style>
  /* Ensure the background is dark and viewport covers full height */
  :global(html),
  :global(body) {
    background-color: #0f172a;
    color: white;
    margin: 0;
    padding: 0;
    width: 100%;
    height: 100%;
    min-height: 100vh;
    overflow-x: hidden; /* Prevent horizontal scroll */
  }

  .app-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    min-height: 100vh;
    position: relative;
    overflow-x: hidden; /* Prevent horizontal scroll */
  }
</style>